export enum CollapsiblePositionBaseValue {
  Particulars = 500,
  UnitActivity = 1000,
  SagaForms = 1100
}
